import cfg_newtab from '../api/cfg/newtab';
import cfg_errorpage from '../api/cfg/errorpage';

/**
 * 获取配置信息
 */
export default {
  /**
   * 获取配置数据
   * @param {string} pageType 页面类型： newtab|errorpage
   * @param {string} cfgName 配置key， 支持多级读取：例如 LeftNews.newsList
   * @returns {undefined} 返回 undefinded | Object
   */
  getCfg (pageType, cfgName) {
    let retVal = undefined, cfgNames = this.parseCfgName(cfgName);
    switch (pageType) {
      case 'newtab':
        do {
          let cfgKey = cfgNames.shift();
          retVal = cfg_newtab.getCfg(cfgKey, retVal);
          if (!!retVal === false) {
            break ;
          }
        } while (cfgNames.length > 0);
        break ;
      case 'errorpage':
        do {
          let cfgKey = cfgNames.shift();
          retVal = cfg_errorpage.getCfg(cfgKey, retVal);
          if (!!retVal === false) {
            break ;
          }
        } while (cfgNames.length > 0);
        break ;
      default:
        console.log('pageType error:', pageType);
        break;
    }
    return retVal;
  },

  /**
   * 解析配置key
   * @param {string} cfgName 配置key
   * @returns {any} 返回数组
   */
  parseCfgName (cfgName) {
    cfgName = cfgName.trim();
    return (cfgName ? cfgName.split('.') : []);
  },
}
